import { Modal } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";

export default function TermsModal(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      className="terms-modal"
    >
      <Modal.Header>
        <Modal.Title>서비스 이용약관(담다CRM)</Modal.Title>
        <button
          className="btn close-btn"
          style={{ fontSize: "1.3rem", padding: "0.5rem 1rem" }}
          onClick={() => props.onHide()}
        >
          <BsXLg />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h3>제 1조 (목적)</h3>

        <p>
          본 약관은 주식회사 담다(Damdaa Co., Ltd.)(이하 회사)이 제공하는
          CRM회원 서비스(사용자용)를 이용함에 있어 회사와 회원의 권리·의무,
          책임사항 및 기타 필요한 사항을 규정함을 목적으로 한다.
        </p>

        <h3>제 2조 (정의)</h3>

        <p>
          이 약관에서 사용하는 용어의 정의는 다음과 같다. 본 조에 의하여
          정의되지 않은 본 약관상의 용어의 의미는 일반적인 거래관행에 따른다.
        </p>

        <p>
          {" "}
          1. 사이트란, 회사가 서비스를 회원에게 제공하기 위하여 컴퓨터 등
          정보통신설비를 이용하여 설정한 가상의 영업장을 의미한다. 현재 회사가
          운영하는 사이트는 아래와 같으며, 더불어 서비스를 제공하는 안드로이드,
          iOS 환경의 서비스를 포함한 모바일 앱과 웹사이트를 포함한다.
        </p>
        <span> 1)https://crm.담다페이.kr/</span>
        <span>
          {" "}
          2)그 외 회사에서 공지 및 운영하는 기타 모바일 앱 및 웹사이트{" "}
        </span>
        <p>
          {" "}
          2. 서비스란, 담다CRM 서비스에 가입한 회원이 파트너의 매장 내 상품 및
          용역(이하 상품 등)을 구매하거나 미리 상품 등 구매 금원을 해당 파트너에
          지급함에 따라 해당 파트너로부터 포인트/쿠폰을 제공받고 향후 회원이
          해당 파트너의 매장에서 포인트/쿠폰을 이용하여 상품 등과 교환하는 것을
          더 편리하게 하게끔 회사가 회원에게 제공하는 인터넷 기반의 서비스(관련
          부가서비스 포함) 등 제6조에 정의된 서비스를 의미한다.
        </p>

        <p>
          {" "}
          3. 회원이란, 회사의 서비스에 접속하여 본 약관에 따라 회사와 서비스
          이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 자를 의미한다.
        </p>
        <p>
          {" "}
          4. 파트너란, 매장을 관리·운영할 권한이 있어 담다CRM
          이용약관(파트너용)에 따라 회사와 담다CRM 이용계약을 체결하고, 회사가
          제공하는 서비스를 이용하기로 제휴한 자를 의미한다.
        </p>
        <p>
          {" "}
          5. 매장이란, 임의의 건축물 내에서 상품 등을 판매하는 일정 범위의
          장소(영업장)을 의미한다.
        </p>
        <p>
          {" "}
          6. 포인트/쿠폰란, 회원이 매장에서 상품 등을 구매하거나 미리 상품 등
          구매 금원을 해당 매장에게 지급할 경우 해당 매장이 해당 회원에게
          지급하는 것으로서, 회원은 해당 매장의 포인트/쿠폰을 소진시켜 매장의
          상품 등을 구매할 수 있다.
        </p>
        <p>
          {" "}
          7. 등급이란, 파트너의 매장별로 회원에게 부여하는 지위로, 회원의
          구매이력에 따른 차등적 혜택을 제공하기 위한 기준이 된다.
        </p>
        <p>
          {" "}
          8. 모바일 앱이란, 회사가 회원에게 모바일 환경에서 서비스를 제공하기
          위하여 관리·운영하는 어플리케이션(App)을 의미하며, 회원은 모바일 앱을
          통하여 매장 별 적립 포인트 및 혜택 확인 등 다양한 기능을 이용할 수
          있다.
        </p>
        <p>
          {" "}
          9. 제휴사란, 회원이 담다CRM 서비스를 이용하여 상품 등을 구매할 경우
          자신이 운영하는 모바일 어플리케이션 및 웹사이트에서 사용할 수 있는
          포인트를 회원에게 지급하는 등 회원에게 부가적인 서비스를 제공하는
          업체로서 회사와의 이에 관한 사업 제휴 계약을 체결한 업체를 말한다.
        </p>
        <p>
          10. 제휴사 포인트/쿠폰란, 회원이 상품 등을 구매할 경우 제휴사가
          회원에게 지급하는 포인트/쿠폰`을 의미한다.
        </p>

        <h3>제 3조 (약관의 명시, 효력 및 개정)</h3>

        <p>
          {" "}
          1. 회사는 본 약관의 내용과 상호 및 대표자 이름, 주소, 전화번호,
          이메일, 사업자등록번호 등을 회원이 쉽게 알 수 있도록 사이트의
          초기화면에 게시한다. 다만, 약관의 구체적 내용은 회원이 연결화면을
          통하여 볼 수 있도록 할 수 있다.
        </p>
        <p>
          {" "}
          2. 회사는 『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의
          규제에 관한 법률』, 『전자문서 및 전자거래 기본법』, 『전자서명법』,
          『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『소비자기본법』
          등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있다.
        </p>
        <p>
          {" "}
          3. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행
          약관과 함께 사이트의 초기화면에 그 적용일자 7일 이전부터 적용일자
          전일까지 공지하기로 한다. 다만, 회원에게 불리한 약관의 개정의 경우에는
          적용일자 30일 전 전자우편, 전자메시지 등 전자적 수단을 통해 회원에게
          변경사항을 통지하기로 한다.
        </p>
        <p>
          {" "}
          4. 제3항에 의해 변경된 약관은 관련 법령에 특별한 규정, 기타 부득이한
          사유가 없는 한 그 적용일자 이전으로 소급하여 적용되지 아니한다.
        </p>
        <p>
          {" "}
          5. 제3항에 따라 공지 또는 통지하면서 회원에게 7일(단, 회원에게 불리한
          변경은 30일) 내에 개정 약관 적용 거부의 의사표시를 하지 아니하면 개정
          약관 적용에 동의한 것으로 본다는 뜻을 공지 또는 통지하였음에도
          불구하고 회원이 위 기간 내에 명시적으로 거부의사를 표명하지 않을 경우
          회원은 개정된 약관에 동의하는 것으로 간주하며, 변경된 약관에 동의하지
          않는 의사표시를 한 회원과 회사는 서비스 이용 계약을 해지할 수 있다.
          단, 본 약관의 권리, 의무에 영향을 주지 않는 서비스에 대한 새로운
          기능과 관련된 변경, 법령의 개정 후 법령을 준수하기 위한 변경, 오탈자
          수정 또는 표현의 변경은 사전 공지 없이 즉시 발효될 수 있다.
        </p>
        <p>
          {" "}
          6. 회사는 제공하는 서비스 내의 개별 서비스에 대한 별도의 약관 또는
          이용조건을 둘 수 있으며 개별 서비스에서 별도로 적용되는 약관에 대한
          동의는 회원이 개별 서비스를 최초로 이용할 경우 별도의 동의절차를
          거치게 된다. 이 경우 개별 서비스에 대한 이용약관 등이 본 약관에
          우선한다.
        </p>
        <p>
          {" "}
          7. 회원은 사이트의 초기화면의 공지사항 또는 회원가입 시 등록한
          전자우편을 통해서 이 약관의 변경사항을 확인할 주의의무가 있고, 제5항의
          조치에도 불구하고 약관의 개정 사실을 알지 못함으로써 발생하는 회원의
          피해에 대하여 회사는 책임지지 아니한다.
        </p>
        <p>
          {" "}
          8. 본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여는
          관련법령의 규정과 일반 상관례에 따른다.
        </p>
        <h3>제 4조 (서비스 이용 신청 및 승낙)</h3>
        <p>
          {" "}
          1. 회원 가입을 희망하는 자(이하 가입신청자)는 회사가 정한 가입양식에
          따라 회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 함으로써
          회원가입을 신청한다.
        </p>
        <p>
          {" "}
          2. 회사는 제1항과 같이 회원으로 가입할 것을 신청한 가입신청자 중 다음
          각 호에 해당하지 않는 한 회원으로 등록한다. 만약 회사가 회원가입신청의
          승인을 거부하거나 유보하는 경우, 회사는 해당 가입신청자에게 즉시
          사유와 함께 이를 통지한다.
        </p>
        <span>
          {" "}
          1) 가입신청자가 기입한 회원정보에 명백한 허위 기재, 누락 또는 오기가
          있는 경우
        </span>
        <span>
          {" "}
          2) 회사가 회원의 본인확인 절차를 실시하여 본인 확인이 되지 않거나
          본인이 아님이 확인된 경우
        </span>
        <span> 3) 이미 가입된 회원이 중복 신청한 경우</span>
        <span> 4 )이전에 회원자격을 상실한 적이 있는 경우</span>
        <span>
          {" "}
          5) 본 약관의 목적을 초과하여 부정한 용도 또는 영리를 추구할 목적으로
          서비스를 이용하고자 하는 경우
        </span>
        <span>
          {" "}
          6) 회사가 가입신청인의 기재 사항에 관한 증빙을 요청한 경우 이에 응하지
          않거나 허위의 증빙을 제출하는 경우
        </span>
        <span>
          {" "}
          7) 기타 가입신청자를 회원으로 등록하는 것이 기술상 불가능하거나,
          사이트의 운영 또는 관리에 현저한 지장을 준다고 판단되는 경우
        </span>
        <p>
          {" "}
          3. 회원가입 계약의 성립시기는 회사의 승낙이 가입신청자에게 도달한
          시점으로 한다.
        </p>
        <p>
          {" "}
          4. 회원은 언제든지 본인의 개인정보를 열람하고 수정할 수 있다. 다만,
          서비스 관리를 위해 필요한 단말기 식별번호(디바이스 아이디 또는 IMEI)
          등은 수정할 수 없다.
        </p>
        <p>
          {" "}
          5. 회원은 회원정보에 변경이 있는 경우, 회원정보 수정 등의 방법으로 그
          변경사항을 반영하여야 한다. 회원정보 수정을 하지 않음으로써 발생하는
          회원의 손해에 대하여 회사는 아무런 책임을 지지 않는다.
        </p>
        <h3>제 5조 (회원 탈퇴, 자격 제한 등)</h3>
        <p>
          {" "}
          1. 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며, 회사는 회원의
          회원탈퇴 요청 즉시 회원탈퇴를 처리한다. 회원탈퇴 시 소진되지 않은
          포인트 및 혜택은 회원의 의사에 따라 이에 대한 권리를 포기한 것으로
          간주하여 탈퇴와 동시에 전부 소멸된다.
        </p>
        <p>
          {" "}
          2. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원의 자격을 제한
          또는 상실시킬 수 있다. 회원이 회원자격을 상실할 경우 보유한 쿠폰,
          포인트, 혜택은 전부 소멸된다.
        </p>
        <span>
          {" "}
          1) 제4조 제2항의 규정에 따른 회사의 이용계약 거부 사유가 있는 경우
        </span>
        <span>
          {" "}
          2) 회원정보에 허위 내용을 입력하거나 타인의 정보를 도용한 경우
        </span>
        <span>
          {" "}
          3) 사이트의 이용과 관련하여 회원이 부담하는 채무를 기일에 이행하지
          않는 경우
        </span>
        <span>
          {" "}
          4) 회사나 다른 회원 및 제3자의 권리나 명예, 신용 등 기타 정당한 이익을
          침해하거나 법령 또는 미풍양속에 위배되는 행위를 하는 경우
        </span>
        <span>
          {" "}
          5) 다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 부정한
          행위를 하는 경우
        </span>
        <span>
          {" "}
          6) 회사의 원활한 서비스 제공을 방해하는 행위를 하거나 그러한 행위를
          시도한 경우
        </span>
        <span>
          {" "}
          7) 주소, 전자우편 등 회원정보를 잘못 입력하거나 변경하지 않는 등
          회원의 귀책사유로 인하여 회사가 상당한 노력을 기울였음에도 불구하고
          회원에게 통지 또는 연락을 할 수 없게 된 경우
        </span>
        <span> 8) 본 약관 제10조 회원의 의무를 위반하는 행위를 하는 경우</span>
        <span>
          {" "}
          9) 본 약관의 규정 또는 회사의 이용정책 등을 위반하거나 법령 기타
          공서양속에 반하는 행위를 하는 경우
        </span>
        <p>
          {" "}
          3. 회사는 회원의 서비스 이용을 단계적으로 제한(경고, 일시정지,
          영구정지 등)할 수 있다.
        </p>
        <p>
          {" "}
          4. 회사가 회원 자격을 제한시킨 후 동일한 행위가 2회 이상 반복되거나
          30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원에게 통지 후
          회원 자격을 상실시킬 수 있다.
        </p>
        <p>
          {" "}
          5. 회원의 탈퇴, 자격 상실 등으로 서비스 이용계약이 종료된 경우, 이에
          관하여 발생한 손해는 회원 자신이 부담하여야 하며, 회사는 일체의 법적
          책임을 부담하지 않는다.
        </p>
        <p>
          {" "}
          6. 회원은 본 조에 따른 자격 제한 또는 상실 조치에 대하여 회사가 정한
          절차에 따라 이의를 신청할 수 있다. 회사는 회원의 이의가 정당하다고
          인정할 경우 즉시 서비스의 이용을 재개하기로 한다.
        </p>
        <h3>제 6조 (서비스의 제공, 변경, 중단, 종료)</h3>
        <p> 1. 회사는 다음 각 호와 같은 서비스를 회원에게 제공하기로 한다.</p>

        <span> 1) 포인트 적립 및 이용 지원 서비스</span>
        <span> 2) 혜택 제공 및 이용 지원 서비스</span>
        <span> 3) 제휴 매장 검색 및 추천 서비스</span>
        <span> 4) 제휴사의 혜택 및 행사 등 안내 및 추천 서비스</span>
        <span> 5) 제휴사 포인트 적립 및 이용 지원 서비스</span>
        <span> 6) 이에 수반되는 기타 서비스 일체</span>
        <p>
          {" "}
          2. 회사는 신규 서비스로의 전환, 서비스 포기, 회사의 폐업, 합병, 분할,
          영업양도, 이용자 감소 등으로 인한 원활한 서비스 제공의 곤란 및 수익성
          악화, 기술 진보에 따른 차세대 서비스로의 전환 필요성 회사 정책의 변경
          등 운영상, 기술상의 상당한 이유가 있을 경우, 제공하고 있는 서비스의
          전부 또는 일부를 변경 또는 종료할 수 있으며, 이 경우, 회사는 회원에게
          서비스 변경 또는 종료될 서비스의 내용, 사유, 시기 등을 사이트 및
          전자문서 등 회원이 충분히 인지할 수 있는 방법으로 변경일(또는
          종료일)로부터 30일 전 공지한다.
        </p>
        <p>
          {" "}
          3. 회사는 서비스의 전부 또는 일부를 회사의 정책 및 운영상 이유로
          임의로 변경 또는 종료할 수 있으며, 관련 법령 및 개별약관에서 특별히
          정하지 않는 한 회원에게 별도의 보상은 실시하지 않는다.
        </p>
        <p>
          {" "}
          4. 회사는 서비스의 제공 중단의 사유가 발생한 경우 제3조 제3항에서 정한
          방법으로 회원에게 공지 후 일시적으로 중단할 수 있다. 다만, 천재지변
          또는 이에 준하는 불가항력, 정보통신설비의 보수점검·교체, 고장, 통신의
          두절, 정전, 이용량의 폭주, 제휴사와의 계약 종료, 제휴사의 제휴 거절,
          정부의 명령/규제 등 운영상 상당한 이유가 있는 경우 서비스 제공을
          제한하거나 중단할 수 있고 서비스 제공이 제한 또는 중단되는 경우에는
          사후 공지할 수 있다.
        </p>
        <p>
          {" "}
          5. 회사는 서비스(개별 서비스 포함) 제공에 필요한 경우 정기점검을
          실시할 수 있으며, 정기점검시간은 사이트 내 공지사항 화면에 공지한 바에
          의한다.
        </p>

        <h3>제 7조 (회원에 대한 통지)</h3>
        <p>
          {" "}
          1. 회사가 회원에 대한 통지를 하는 경우, 본 약관에 별도 규정이 없는 한
          휴대폰번호, 카카오톡, 서비스 내 전자우편, 전자 메시지 등으로 할 수
          있다.
        </p>
        <p>
          {" "}
          2. 회사는 불특정다수 회원에 대한 통지의 경우 7일 이상 사이트 내
          공지사항에 게시함으로써 개별 통지에 갈음할 수 있다. 다만, 회원 본인의
          거래에 관련하여 중대한 영향을 미치는 사항에 대하여는 개별 통지한다.
        </p>
        <h3>제 8조 (정보의 제공 및 광고의 게재)</h3>
        <p>
          {" "}
          1. 회사는 서비스 이용 중 필요하다고 인정되는 다양한 정보를 서비스 내
          공지사항, 서비스 화면, 모바일 앱 등의 방법으로 회원에게 제공할 수
          있다.
        </p>
        <p>
          {" "}
          2. 회사는 회원의 마케팅 정보 수신 동의 여부에 따라 서비스의 운영과
          관련하여 회원의 서비스 화면, 모바일 앱, 전자우편, 전자 메시지 등을
          통하여 광고를 게시 또는 전송할 수 있으며, 회원의 사전 동의를 받지 않는
          영리목적의 광고성 정보를 게시 또는 전송하지 않는다.
        </p>
        <p>
          {" "}
          3. 전항에도 불구하고, 회사가 본 약관에 따른 재화 또는 용역의
          거래관계를 통하여 회원으로부터 직접 연락처를 수집하고, 6개월 이내에
          자신이 취급하고 회원과 거래한 것과 동종의 재화 또는 용역에 대한
          영리목적의 광고성 정보를 전송하려는 경우 회원의 명시적인 사전동의가
          없더라도 광고성 정보를 전송할 수 있다.
        </p>
        <p>
          {" "}
          4. 회원이 서비스 상에 게재되어 있는 광고를 이용하거나 서비스를 통한
          광고주의 판촉활동에 따른 상품 등을 이용하는 경우, 이는 전적으로 회원과
          광고주 간의 법률 관계이므로, 그로 인해 발생하는 회원과 광고주간 분쟁
          등 제반 문제는 회원과 광고주간에 직접 해결하여야 하며, 이와 관련하여
          회사는 어떠한 책임도 지지 아니한다.
        </p>
        <h3>제 9조 (회사의 의무)</h3>
        <p>
          {" "}
          1. 회사는 본 약관이 금지하거나 관련 법령 기타 공서양속에 반하는 행위를
          하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를
          제공하는 데 최선을 다한다.
        </p>
        <p>
          {" "}
          2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의
          개인정보(신용정보 포함)보호를 위한 보안시스템을 갖추어야 하며,
          개인정보처리방침을 공시하고 준수한다.
        </p>
        <p>
          {" "}
          3. 회사는 회원으로부터 제기되는 의견이나 불만이 객관적으로 정당하다고
          인정될 경우에는 회원의 불만을 해결하기 위해 노력한다. 회원이 제기한
          의견이나 불만사항에 대해서는 회원에게 처리과정 및 결과를 전달한다.
        </p>

        <h3>제 10조 (회원의 의무)</h3>
        <p>
          {" "}
          1. 회원은 다음 각 호의 행위를 하여서는 아니 된다. 만일, 회원이 다음 각
          호의 행위를 하여 회사 및 제3자에게 손해가 발생한 경우, 회원은 그에
          대하여 자신의 책임으로 책임을 부담하며, 회사를 면책하여야 한다.
        </p>
        <span>
          {" "}
          1) 회원가입 신청 또는 회원정보 변경 시 허위 내용을 등록하는 행위
        </span>
        <span> 2) 타인의 정보를 도용하는 행위</span>
        <span>
          {" "}
          3) 회사가 게시한 정보를 무단 변경, 삭제, 전재, 공유, 배포하는 행위
        </span>
        <span> 4) 다른 회원의 개인정보 및 계정정보를 수집하는 행위</span>
        <span>
          {" "}
          5) 회사의 사전동의 없이 영리 목적으로 서비스를 이용하거나, 광고성
          정보를 전송하기 위하여 서비스를 이용하는 행위
        </span>
        <span>
          {" "}
          6) 리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의 가공행위를
          통한 서비스의 복제, 분해, 모방 및 기타 변경 등을 하는 행위
        </span>
        <span>
          {" "}
          7) 자동접속 프로그램을 사용하는 등 비정상적인 방법으로 서비스를
          이용하여 회사의 서버에 부하를 일으켜 정상적인 서비스의 제공 또는
          이용을 방해하는 행위
        </span>
        <span> 8) 본인이 아닌 제3자에게 접속 권한을 부여하는 행위</span>
        <span> 9) 회사 또는 제3자의 지적재산권을 침해하는 행위</span>
        <span>
          {" "}
          10) 회사 또는 제3자의 명예를 훼손하거나 업무를 방해하는 행위
        </span>
        <span>
          {" "}
          11) 외설 또는 폭력적인 메시지, 화상, 음성, 기타 미풍양속에 반하는
          정보를 서비스에 공개 또는 게시하는 행위
        </span>
        <span>
          {" "}
          12) 회사가 안내하는 서비스 이용방법에 의하지 아니하고 비정상적인
          방법으로 서비스를 이용하거나 회사의 시스템에 접근하는 행위
        </span>
        <span> 13) 다른 회원의 서비스 이용을 방해하는 행위</span>
        <span>
          {" "}
          14) 기타 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의
          행위
        </span>
        <p>
          {" "}
          2. 회원은 관계법령, 본 약관, 이용안내 및 서비스와 관련하여 회사가
          통지하는 사항 등을 준수하여야 하며, 위 사항을 위반하거나 기타 회사의
          업무에 방해되는 행위를 하여서는 아니 된다.
        </p>
        <p>
          {" "}
          3. 휴대전화번호에 관한 관리책임은 회원에게 있으며, 이를 소홀히 하여
          발생한 모든 민∙형사상의 책임은 회원 자신에게 있다.
        </p>
        <p>
          {" "}
          4. 회원의 휴대전화번호 변경에 따라 기존에 수신 받은 혜택이 삭제된 경우
          재발송이 불가하며, 휴대전화번호 변경 시에 혜택의 보관 및 이전의 책임은
          회원에게 있다.
        </p>
        <h3>제11조 (이용자의 정보보호)</h3>
        <p>
          {" "}
          1. 회사는 정보통신망에 중대한 침해사고가 발생하여 회사의 서비스를
          이용하는 회원의 정보시스템 또는 정보통신망 등에 심각한 장애가 발생할
          가능성이 있는 경우에는 회원에 대한 보호조치를 이메일, 공지사항 등의
          방법으로 요청할 수 있다.
        </p>
        <p> 2. 회원이 취할 보호조치의 내용은 아래 각 호와 같다.</p>
        <span>
          {" "}
          1) 해당 장비의 네트워크로부터 연결케이블 제거, 서비스 포트 차단,
          네트워크 주소 차단 등의 즉각적인 분리
        </span>
        <span> 2) 해당 장비에 대한 보안점검</span>
        <span>
          {" "}
          3) 관련 원인점검 및 패치, OS재설치, 필터링 등의 사후 보안 조치 실시
        </span>
        <p>
          {" "}
          3. 회사는 회원이 전항의 보호조치를 이행하지 아니할 경우 회원이
          보호조치를 취할 때까지 이용자의 서비스 이용을 제한할 수 있다.
        </p>
        <h3>제 12조 (포인트 등 적립 및 이용)</h3>
        <p>
          {" "}
          1. 파트너 운영 매장에서 상품 등을 구입하고 그에 따른 대금을 결제한
          회원은 해당 매장에서 지급하는 포인트, 쿠폰과 별도로 회사와 제휴사가
          약정한 바에 따라 제휴사 포인트, 쿠폰을 추가로 제공받을 수 있다. 단,
          결제액에 따른 제휴사 포인트, 쿠폰의 적립률, 회원에 대한 제휴사 포인트,
          쿠폰 부여와 복구, 결제수단 등 충전 방식과 사용정책, 유효기간 등 세부
          사항은 제휴사가 정하거나 제휴사의 자체적인 제휴사 포인트, 쿠폰 관련
          정책에 따르며, 제휴사의 제휴사 포인트, 쿠폰 관련 정책에 대해서는
          제휴사가 책임을 지고 회사는 회원에 대하여 어떠한 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          2. 회원이 특정 상품 등을 구매하거나 포인트, 쿠폰 또는 혜택을 결제
          수단으로 사용하는 경우, 별도의 포인트, 쿠폰 적립률이 적용되거나
          포인트, 쿠폰이 적립되지 않을 수 있다.
        </p>
        <p>
          {" "}
          3. 회원은 파트너가 정한 기준에 따라 포인트, 쿠폰을 합산하여 적립 및
          사용할 수 있으며, 적립한 포인트, 쿠폰은 파트너가 정한 범위 내의 상품
          등으로 교환하거나 구매대금의 일부로 사용할 수 있다. 단, 파트너는
          매장별로 혜택 사용을 위한 조건(최소 구매금액 설정, 다른 포인트 또는
          혜택과의 중복사용 불가 등)을 부가할 수 있다.
        </p>
        <p>
          {" "}
          4. 회원은 본인이 소유한 포인트를 타인에게 양도, 대여 또는 담보의
          목적으로 이용할 수 없다.
        </p>
        <p>
          {" "}
          5. 회원은 적립한 포인트, 쿠폰을 부정하게 이용하여서는 아니 되며,
          회사는 포인트, 쿠폰에 대한 적법한 권리가 있는 회원으로부터 부정이용
          신고 등을 접수한 경우에는 즉시 이를 해결하기 위한 조치를 취하기로
          한다.
        </p>
        <p>
          {" "}
          6. 회원은 적립된 포인트, 쿠폰을 금전 등 다른 지급수단의 형태로 교환
          또는 환불해 줄 것을 요청할 수 없다.
        </p>
        <p>
          {" "}
          7. 포인트, 쿠폰 적립률 및 기준은 파트너의 방침에 따라 임의로 변경될 수
          있으며, 회사는 회원에게 파트너의 포인트, 쿠폰 적립률 및 기준 변경에
          관하여 어떠한 책임을 지지 아니한다.
        </p>
        <p>
          {" "}
          8. 회원정보의 변경으로 인한 포인트 이전 등의 처리는 회사의 내부 방침에
          따른다.
        </p>
        <h3>제 13조 (포인트 등 충전)</h3>
        <p>
          {" "}
          1. 회원은 특정 파트너가 인정하는 결제수단으로 특정 파트너에게 대가를
          미리 지급하여 포인트, 쿠폰을 충전할 수 있다.
        </p>
        <p>
          {" "}
          2. 다음 각호에 해당하는 경우 회사 또는 파트너는 회원의 충전을 제한할
          수 있다.
        </p>
        <span> 1) 파트너의 충전 정책에 반하는 경우</span>
        <span>
          {" "}
          2) 비정상적인 방법으로 서비스를 이용하는 것으로 판단되는 경우
        </span>
        <span>
          {" "}
          3) 타인의 명의, 계좌정보 등을 도용하여 충전하는 것으로 판단되는 경우
        </span>
        <span> 4) 기타 충전이 불가능한 기술적, 제도적 사유가 발생한 경우</span>
        <p>
          {" "}
          3. 회원은 본 조의 충전에 관한 사항은 파트너의 각 정책에 따라 운영되고
          있으며, 회원과 파트너 사이에 포인트 충전에 관한 분쟁이 발생할 경우에도
          회사는 해당 분쟁을 해결하거나 중재할 의무가 없으며, 이에 관하여 아무런
          법적 책임을 부담하지 않는 것임을 이해하였으며, 이에 동의한다.
        </p>
        <h3>제 14조 (포인트 등 정정, 취소)</h3>
        <p>
          {" "}
          1. 적립된 포인트, 쿠폰에 오류가 있을 경우 회원은 오류발생 시점부터 7일
          이내 회사나 파트너에 정정 신청을 하여야 하며, 회사나 파트너는 회원의
          정정 신청일로부터 최대 30일 이내에 조치를 취하기로 한다. 단, 회원은
          필요한 경우 포인트, 쿠폰 적립 오류를 증명할 수 있는 객관적 자료(영수증
          등)를 제시하여야 한다.
        </p>
        <p>
          {" "}
          2. 회원이 상품 등의 구매취소, 반품, 기타의 사유에 의해 포인트, 쿠폰의
          적립이 취소되는 경우 취소분만큼 기 지급된 포인트, 쿠폰은 자동으로
          차감된다.
        </p>
        <p>
          {" "}
          3. 제휴사 포인트, 쿠폰에 관해서는 제휴사가 정하거나 제휴사의 자체적인
          제휴사 정책에 따르며, 제휴사의 제휴사 정책에 대해서는 제휴사가 책임을
          지고 회사는 회원에 대하여 어떠한 책임을 지지 않는다.
        </p>
        <h3>제 15조 (포인트 유효기간 및 소멸)</h3>
        <p>
          {" "}
          1. 회원이 회원 탈퇴하는 경우 및 포인트, 쿠폰의 유효기간이 만료되는
          경우 회원의 포인트, 쿠폰은 소멸된다.
        </p>
        <p>
          {" "}
          2. 포인트, 쿠폰의 유효기간은 파트너의 각 정책에 따른다. 위 유효기간
          내에 사용되지 않은 포인트, 쿠폰은 유효기간 만료일의 익일에 먼저 적립된
          포인트, 쿠폰부터 일 단위로 자동 소멸된다.
        </p>
        <p>
          {" "}
          3. 회원탈퇴 및 유효기간 만료로 인하여 소멸된 포인트, 쿠폰은 다음 각
          호에서 정한 바에 따라 처리된다.
        </p>
        <span>
          {" "}
          1) 회원탈퇴로 인한 소멸 : 회원탈퇴 처리 완료일까지 적립된 포인트,
          쿠폰은 회원탈퇴 이후 사용이 불가하다.
        </span>
        <span>
          {" "}
          2) 유효기간 만료로 인한 소멸 : 유효기간이 만료된 포인트, 쿠폰은 어떠한
          경우에도 복원되지 않는다.
        </span>
        <p>
          {" "}
          4. 회사는 유효기간 만료에 따른 소멸예정 포인트, 쿠폰, 소멸시기 등
          포인트, 쿠폰 소멸과 관련된 내용을 회원이 모바일 앱에서 확인할 수
          있도록 조치한다.
        </p>
        <p>
          {" "}
          5. 제휴사의 포인트, 쿠폰 유효기간 및 소멸은 제휴사가 정하거나 제휴사의
          관련 정책에 따르며, 제휴사의 정책에 대해서는 제휴사가 책임을 지고
          회사는 회원에 대하여 어떠한 책임을 지지 않는다.
        </p>
        <h3>제 16조 (혜택 이용)</h3>
        <p>
          {" "}
          1. 회원은 파트너의 포인트, 쿠폰 제공에 대하여 동의 또는 거부할 수
          있으며, 파트너는 동의를 표시한 회원에 대하여 전자 메시지, 전자우편
          또는 그 밖의 수단으로 포인트, 쿠폰을 전송할 수 있다.
        </p>
        <p>
          {" "}
          2. 회원은 매장별로 파트너가 정한 기준에 따라 포인트, 쿠폰을
          사용함으로써 해당 매장의 상품 등으로 교환하거나 할인된 가격으로 구매할
          수 있다. 단, 파트너는 매장별로 포인트, 쿠폰 사용을 위한 조건(최소
          구매금액 설정, 중복사용 불가 등)을 부가할 수 있다.
        </p>
        <p>
          {" "}
          3. 회원은 파트너가 정한 포인트, 쿠폰의 유효기간 내에 포인트, 쿠폰을
          사용하여야 하며, 유효기간이 경과한 포인트, 쿠폰은 자동 소멸된다. 단,
          회원탈퇴 또는 자격상실 시 지급받은 포인트, 쿠폰은 자동으로 소멸된다.
        </p>
        <p>
          {" "}
          4. 회원이 과실 또는 고의로 수령한 포인트, 쿠폰을 삭제한 경우에는
          회원은 파트너에게 포인트, 쿠폰의 복구를 요청할 수 있으며 회사는
          파트너가 요청할 경우 그 내용에 따라 포인트, 쿠폰의 복구를 처리한다.
          단, 파트너가 매장별 상황을 고려하여 복구 요청을 거절하는 경우, 회사는
          이에 대하여 책임을 지지 않는다.
        </p>
        <h3>제 17 조 (모바일 앱 이용)</h3>
        <p>
          {" "}
          1. 회원은 모바일 앱을 이용하여 매장별 포인트 적립 및 혜택 지급 현황을
          확인하거나, 회원의 현재 위치 주변에 소재한 제휴 매장을 검색할 수 있다.
        </p>
        <p>
          2. 회원이 모바일 앱을 이용하고자 하는 경우, 회원은 회사가 회원의
          위치정보를 이용한 서비스 제공을 목적으로 하는 담다CRM위치정보
          이용약관에 동의하고, 본인의 위치정보를 회사에 제공하여야 한다.
        </p>
        <h3>제 18조 (콘텐츠)</h3>
        <p>
          {" "}
          1. 회사의 서비스를 통하여 제공되는 모든 정보 및 게시물 등(이하
          콘텐츠라 함)의 지식재산권은 회사에 있으며, 회원은 본 약관의 내용에
          따라 서비스를 이용하는 것 외에는 지식재산권에 대한 어떠한 권리와
          이익도 가지지 아니한다.
        </p>
        <p>
          {" "}
          2. 회원은 회사의 콘텐츠를 서비스 제공 목적 외로 사용할 수 없고, 회원은
          직접 또는 특수관계인을 이용하는 등 간접적인 방법으로 서비스에 관련된
          지적재산권을 침해하거나 회사의 지적재산권 행사를 방해해서는 아니된다.
          상기 침해 행위에는 서비스에 관한 복제, 역설계, 해독, 역편집, 해체,
          분석, 소스코드 도출, 개조, 변환, 파생 작업, 조정, 다른 소프트웨어와의
          병합, 결함 수정, 보안 기능의 우회, 등록 시도, 타인에게 서비스를
          사용하게 하는 등 본 약관의 내용을 넘어서는 서비스의 사용이 포함된다.
        </p>
        <p>
          {" "}
          3. 회원은 서비스 내 등록하는 게시물이 제3자의 상표권, 특허권, 저작권,
          성명권, 초상권 등 제반 지식재산권, 인격권을 침해하지 않으며, 회사 정책
          가이드를 준수하고, 제3자의 초상권, 지식재산권을 사용한 경우 정당한
          권리자로부터 사용 허락을 받았음을 보증한다. 회사는 이러한 보증에
          부합하지 아니하는 회원의 게시물을 수정하거나 삭제할 수 있고, 회원의
          게시물에 관하여 제3자가 지식재산권과 관련한 권리침해 이의제기 또는
          소송이 발생할 경우 회사는 해당 게시물을 차단하거나 삭제할 수 있으며,
          이 경우 회원은 회사를 면책시켜야 하며 그로 인해 발생하는 회사와
          제3자의 모든 손해를 배상하여야 한다.
        </p>
        <p>
          {" "}
          4, 회사는 게시물을 무상으로 이용할 권리를 가진다(배포권, 복제권,
          공연권, 공중송신권, 전시권 및 번역 · 편곡 · 변형 · 각색 · 영상제작 그
          밖의 방법 작성하는 창작물에 대한 이용 권리 포함).
        </p>
        <p> 5. 본 조는 서비스 이용 계약이 종료된 이후에도 효력을 가진다.</p>
        <h3>제 19조 (회사의 면책)</h3>
        <p>
          {" "}
          1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를
          제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제된다.
        </p>
        <p>
          {" "}
          2. 회사는 아래 각 호에서 정하는 바에 따라 파트너의 귀책사유로 인한
          서비스 이용의 장애에 대하여 책임을 지지 않는다.
        </p>
        <span>
          {" "}
          1) 파트너(매장 포함)의 휴업, 폐업, 회사와의 약정해지, 서비스 관리부실
          등의 사유로 인하여 회원이 파트너에 적립한 포인트 및 수령한 혜택의
          이용이 불가할 수 있으며, 회사는 이와 관련하여 회원이 입은 손해에
          대하여 책임을 부담하지 않는다.
        </span>
        <span>
          {" "}
          2) 파트너(매장 포함)와 회원 사이에 포인트 및 혜택의 제공, 이용 또는
          이와 관련한 일체의 분쟁이 발생할 경우, 회사는 해당 분쟁을 해결하거나
          중재할 의무가 없으며, 이에 관하여 아무런 법적 책임도 부담하지 않는다.
        </span>
        <p>
          {" "}
          3. 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여
          책임을 지지 않으며, 그 밖의 서비스를 통하여 알게 된 정보를 이용함에
          따라 입은 손해에 대하여 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          4. 회사는 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에
          관해서는 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          5. 회사는 회원 간 또는 회원과 제3자 상호 간에 거래 등을 한 경우에는
          그에 관한 책임을 부담하지 아니한다.
        </p>
        <p>
          {" "}
          6. 회사가 제공하는 서비스는 무상이므로 회사는 회원의 서비스 이용과
          관련하여 관련 법령에 특별한 규정이 없는 한 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          7. 회사는 통신기기, 회선 및 컴퓨터의 장애, 접속의 폭주, 제3자의 해킹,
          전송된 데이터의 오류 및 생략, 누락, 파괴 등 부득이한 사정으로 서비스를
          정상적으로 제공하지 못하여 발생하는 손해에 대하여 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          8. 회사는 서비스에 대한 제3자의 모든 불법적인 접속, 전송, 이용
          등으로부터 발생하는 손해에 대하여 책임을 지지 않는다.
        </p>
        <p>
          {" "}
          9. 회사는 제3자가 서비스 내 화면 또는 링크된 웹사이트를 통하여 광고한
          상품 등의 내용과 품질에 대하여 감시 의무 및 기타 어떠한 책임도 지지
          않는다.
        </p>
        <p>
          {" "}
          10. 회사는 회원 간의 회원정보 등록, 서비스 이용 과정에서 발생하는
          명예훼손, 개인정보침해 또는 기타 불법행위로 인하여 발생하는 손해에
          대하여 책임을 지지 않는다.
        </p>
        <h3>제 20조 (손해배상)</h3>
        <p>
          {" "}
          1. 본 약관의 규정을 위반하여 회사에 손해를 끼친 회원은 회사에 발생한
          모든 손해를 배상해야 한다.
        </p>
        <p>
          {" "}
          2. 회원이 본 서비스를 이용하면서 불법 행위나 본 약관을 위반하는 행위를
          하여 회사가 해당 회원 이외의 제3자로부터 손해배상 청구 또는 소송을
          비롯한 각종 이의제기를 받을 경우 해당 회원은 자신의 책임과 비용으로
          회사를 면책시켜야 하며, 회사가 면책되지 못하면 회사에 발생한 모든
          손해를 배상해야 한다.
        </p>
        <h3>제 21조 (해외 이용)</h3>
        <p>
          {" "}
          회사는 회원이 대한민국의 영토 이외의 지역(이하 해외)에서 서비스를
          이용하고자 하는 경우, 서비스의 품질 및 사용성을 보장하지 않는다.
          따라서 회원은 해외에서 서비스를 이용하고자 하는 경우 스스로의 판단과
          책임 하에 서비스 이용 여부를 결정하여야 하고, 서비스의 이용 과정에서
          현지 법령을 준수할 책임은 회원 본인에게 있다.
        </p>
        <h3>제 22조 (권리, 의무의 양도금지)</h3>
        <p>
          {" "}
          회사와 회원은 상대방의 사전 서면(또는 전자적 방식의) 동의 없이 본
          약관상의 권리 또는 의무의 전부 또는 일부를 제3자에게 양도, 이전,
          증여하거나 이를 담보로 제공할 수 없다. 다만, 회사와 계열회사간 인수,
          합병, 양수도의 경우, 회사는 사이트 내에 이를 공지함으로써 이 약관 상의
          권리 및 의무의 전부를 계열회사에게 이전할 수 있다.
        </p>
        <h3>제23조 (타인 권리 침해 게시물)</h3>
        <p>
          {" "}
          1. 회원은 자신의 게시물이 타인의 저작권이나 명예, 사생활 등 타인의
          권리를 침해하지 않도록 주의하여야 한다.
        </p>
        <p>
          {" "}
          2. 타인의 게시물로 인해 자신의 저작권이나 명예훼손, 사생활이
          침해되었다고 생각하는 회원은 회사에게 침해사실을 소명하여 그 정보의
          삭제 또는 반박내용의 게재를 요청할 수 있다.
        </p>
        <p>
          {" "}
          3. 회사는 전 항의 요청을 받으면 지체 없이 30일 이내의 게시물 접근
          차단ㆍ임시조치 등의 필요한 조치를 하고 즉시 신청인 및 게시물
          게재자에게 알린다.
        </p>
        <p>
          {" "}
          4. 게시물 게재자가 게시물이 신청인의 저작권이나 명예훼손, 사생활 기타
          권리를 침해하지 아니한다는 것에 대한 소명을 한 경우에는 회사는 게시물
          접근 차단ㆍ임시조치를 해제하고 게시물을 원상회복시킬 수 있다. 회사는
          전 항의 요청을 받으면 지체 없이 게시물 게재자에게 게시물이 신청인의
          저작권이나 명예훼손, 사생활 기타 권리를 침해하지 아니한다는 것에 대한
          소명을 요구할 수 있다. 게시물 게재자가 회사로부터 소명 요구를 받은
          날로부터 10일 이내에 소명을 하지 못한 경우 회사는 게시물을 삭제하거나
          소명이 있을 때까지 계속 접근 차단할 수 있다.
        </p>
        <h3>제 24 조 (기타)</h3>
        <p>
          {" "}
          1. 본 약관에서 규정하지 아니한 사항은 관계법령 및 일반 거래 관행에
          의한다.
        </p>
        <p>
          {" "}
          2. 본 약관에 대한 해석 및 분쟁은 대한민국의 법률을 적용하며, 소송이
          제기되는 경우에는 서울중앙지방법원을 전속관할로 한다.
        </p>
        <h3>부칙</h3>
        <p> 이 약관은 2025년 01월 01일부터 시행한다.</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn c-btn-primary btn-primary"
          onClick={() => {
            props.okTerms();
            props.onHide();
          }}
        >
          확인
        </button>
      </Modal.Footer>
    </Modal>
  );
}
